<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<script>
import moduleTraineeExamAnswer from "@/store/traineeExamAnswer/moduleTraineeExamAnswer.js";
import draggable from "vuedraggable";
import { domain } from "@/gloabelConstant.js";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      baseUrl: domain,
      searchCourseExamModel: {},
      examType: 0,
      activePrompt: false,
      selected: [],
      isMounted: false,
      // Data Sidebar
      examModel: {},
      rowDataForDelete: {},
      activeConfirm: false,
      exam_not_found: false,
      activeTab: 0,
      TraineeExamAnswersList: [],
      totalGrade: 0,
    };
  },
  computed: {
    traineeExamAnswers() {
      debugger;
      return this.$store.state.traineeExamAnswerList.traineeExamAnswers;
    },

    isGenerateFormValid() {
      return this.examModel.CourseID && this.examModel.ExamTypeID;
    },
    isFormValid() {
      return true;
    },
  },

  methods: {
    initValues() {
      this.TraineeExamAnswersList = [];
    },
    gradeChange() {
      this.totalGrade = 0;
      this.TraineeExamAnswersList.forEach((e) => {

        if (e.Grade){

           this.totalGrade += parseFloat(e.Grade);
          }

      });
    },

    submitData() {
      this.$store.dispatch(
        "traineeExamAnswerList/MarkTextExam",
        this.TraineeExamAnswersList
      );
      this.initValues();
      this.notifyAlert("success",this.$t("MarkExam"),this.$t("ExamIsMarkedSuccessfully"));
      this.cancle();
    },
    cancle() {
      debugger;
      this.$router.push("/InstructorMarkExam");
    },
    notifyAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
  },

  created() {
    debugger;
    if (!moduleTraineeExamAnswer.isRegistered) {
      this.$store.registerModule(
        "traineeExamAnswerList",
        moduleTraineeExamAnswer
      );
      moduleTraineeExamAnswer.isRegistered = true;
    }

    const ID = this.$route.params.TraineeID;
    const CourseClassID = this.$route.params.CourseClassID;
    const ExamID = this.$route.params.ExamID;

    debugger;
    if (ID != undefined) {
      debugger;
      var data = {
        CourseClassID: CourseClassID,
        ID: ID,
        ExamID: ExamID,
      };
      this.$vs.loading();
      this.$store
        .dispatch(
          "traineeExamAnswerList/GetTraineeExamsAnswerByTraineeID",
          data
        )
        .then((res) => {
          this.$vs.loading.close();

          this.TraineeExamAnswersList =
            this.$store.state.traineeExamAnswerList.traineeExamAnswers;
          this.TraineeExamAnswersList.forEach(
            (e) => {
                if(e.Grade)
                   e.Grade = parseFloat(e.Grade).toFixed(2)
                 this.totalGrade += e.Grade
            }
          );
        })
        .catch((err) => {
          this.$vs.loading.close();
          if (err.response.status === 404) {
            this.exam_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-alert
      color="danger"
      title="Exam Not Found"
      :active.sync="exam_not_found"
    >
      <span>Exam record with id: {{ $route.params.Id }} {{$t('NotFound')}}. </span>
      <span>
        <span>{{$t('Check')}} </span
        ><router-link
          :to="{ name: 'ExamGeneration' }"
          class="text-inherit underline"
          >{{$t('AllExams')}}</router-link
        >
      </span>
    </vs-alert>

    <vx-card
      :title="$t('Question')"
      class="mt-10"
      v-if="TraineeExamAnswersList.length > 0"
    >

      <table>
        <tr>
          <th>{{$t('Date')}}</th>
          <td>
            {{
              TraineeExamAnswersList[0].CreatedDate.replace("T", " ").split(
                "."
              )[0]
            }}
          </td>
        </tr>
        <tr>
          <th>{{$t('TrainingOrderNumber')}}</th>
          <td v-if="TraineeExamAnswersList[0].CourseClassExam.CourseClass">
               {{ TraineeExamAnswersList[0].CourseClassExam.CourseClass.ClassNo }}
          </td>
        </tr>
        <tr>
          <th>{{$t('Course')}}</th>
          <td>{{ TraineeExamAnswersList[0].CourseClassExam.Course.Name }}</td>
        </tr>
        <tr>
          <th>{{$t('TraineeName')}}</th>
          <td>{{ TraineeExamAnswersList[0].Trainee.FullName }}</td>
        </tr>
        <tr>
          <th>{{$t('Grade')}}</th>
          <td>{{ parseFloat(totalGrade).toFixed(2) }}</td>
        </tr>
      </table>
      <vx-card
        class="p-5 mt-5"
        v-for="(item, index) in TraineeExamAnswersList"
        :key="index"
      >
        <div>
          <h6 v-if="item.CourseClassExamQuestion.QuestionTypeID == 1">{{$t('Text')}}</h6>
          <h6 v-if="item.CourseClassExamQuestion.QuestionTypeID == 3">
           {{$t('MultiChoose')}}
          </h6>
          <h6 v-if="item.CourseClassExamQuestion.QuestionTypeID == 2">
           {{$t('TrueFalse')}}
          </h6>

          <div class="vx-col mt-2">
            <h4>
              {{ index + 1 }}-{{ item.CourseClassExamQuestion.QuestionText }}
            </h4>
            <br />
          </div>

          <div
            class="vx-col"
            v-if="item.CourseClassExamQuestion.QuestionTypeID == 1"
          >
            <h5>{{$t('TraineeAnswer')}}</h5>
            <p class="ml-5" v-if="item.AnswerText">{{ item.AnswerText }}</p>
            <p class="ml-5" v-else>{{$t('NoAnswer')}}</p>
          </div>

          <div
            class="vx-col"
            v-if="item.CourseClassExamQuestion.QuestionTypeID == 2"
          >
            <h5>{{$t('TraineeAnswer')}}</h5>
            <p class="ml-5" v-if="item.AnswerText">{{ item.AnswerText }}</p>
            <p class="ml-5" v-else>{{$t('NoAnswer')}}</p>

            <div v-if="item.ExtraAnswerText">
              <h5>{{$t('ExtraTraineeAnswer')}}</h5>
              <p class="ml-5" v-if="item.ExtraAnswerText">
                {{ item.ExtraAnswerText }}
              </p>
            </div>
          </div>

          <div
            class="vx-col"
            v-if="item.CourseClassExamQuestion.QuestionTypeID == 3"
          >
            <div
              class="ml-5"
              v-for="Ans in item.CourseClassExamQuestion
                .CourseClassExamQuestionAnswers"
              :key="Ans.ID"
            >
              <vs-radio
                :disabled="true"
                v-model="item.AnswerText"
                :vs-name="item.CourseClassExamQuestion.ID+''+item.CourseClassExamQuestion.QuestionText"
                :vs-value="Ans.ID"
                >{{ Ans.AnswerText }}</vs-radio
              >
            </div>
            <div v-if="item.ExtraAnswerText">
              <h5>{{$t('ExtraTraineeAnswer')}}</h5>
              <p class="ml-5" v-if="item.ExtraAnswerText">
                {{ item.ExtraAnswerText }}
              </p>
            </div>
          </div>

          <div v-if="item.AttachmentAnswerPath">
            <h5>{{$t('UploadByTrainee')}}</h5>
            <a
              :href="baseUrl + item.AttachmentAnswerPath"
              download
              target="_blank"
              ><feather-icon
                icon="DownloadIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
            /></a>
          </div>

          <div
            class="vx-col mt-2"
            v-if="item.CourseClassExamQuestion.QuestionModelAnswer"
          >
            <h5>{{$t('ModelAnswer')}}</h5>
            <p class="ml-5">
              {{ item.CourseClassExamQuestion.QuestionModelAnswer }}
            </p>
          </div>

          <div class="vx-col mt-2">
            <h5>{{$t('Weight')}}</h5>

            <h5 class="ml-5">{{ item.CourseClassExamQuestion.Weight.toFixed(2) }}</h5>
          </div>
          <div class="vx-col mt-2">
            <h5>{{$t('Grade')}}</h5>
            <vs-input
              class="vx-col ml-5"
              @input="gradeChange()"
              aria-placeholder="Grade"
              v-model="item.Grade"
            />
          </div>
        </div>

        <!--
        <div class="pl-5">
           <div v-for="(ans,indx) in item.CourseQuestionBankAnswers" :key="indx">
              <label>-{{ans.AnswerText}}</label>
           </div>
        </div> -->
      </vx-card>
      <!-- </draggable> -->
    </vx-card>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
            >{{$t('Submit')}}</vs-button
          >
          <vs-button type="border" color="danger" @click="cancle"
            >{{$t('Cancel')}}</vs-button
          >
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

